import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MailViewService } from 'src/app/service/apiservice/mailview.service';
import { updateApproved } from 'src/app/service/modal/approved';
import { Sub, Specification, Remark } from 'src/app/service/modal/pendingrequest';
import { UpdateHcService } from 'src/app/service/apiservice/updatehc.service';
import { Globals } from '../../globals';
import { NgSelectComponent } from '@ng-select/ng-select';
import { ApprovedService } from '../../service/apiservice/approved.service';
import { NgForm } from '@angular/forms';

declare function info_noti(msg: any): any;
declare var $;
@Component({
  selector: 'app-update-hc',
  templateUrl: './update-hc.component.html',
  styleUrls: ['./update-hc.component.css']
})
export class UpdateHcComponent implements OnInit {

  mailId: number;
  mailvalue: string;
  updateData: updateApproved = new updateApproved();
  @ViewChild('updateForm') updateForm: any;

  //subject DropDown//
  subjectDropDown: any;
  subjectDropDown_SelectedId: number[];
  //subject DropDown//

  //Specification DropDown//
  specificationDropDown: any;
  specificationDropDown_SelectedId: number[];
  //Specification DropDown//

  //Remark DropDown//
  remarkDropDown: any;
  remarkDropDown_SelectedId: number[];
  //Remark DropDown//
  eyeIcon: string = "zmdi-eye-off";
  starIcon: string = "zmdi-star-outline";

  @ViewChild('subjectId') subjectId: NgSelectComponent;
  @ViewChild('remarkId') remarkId: NgSelectComponent;
  @ViewChild('specificationId') specificationId: NgSelectComponent;

  submitted: boolean = false;
  senderNameDropDown: any;

  constructor(private route: ActivatedRoute, private router: Router, private _mailService: MailViewService,
    private _updateService: UpdateHcService, private approvedService: ApprovedService, private global: Globals) {

  }

  ngOnInit() {
    debugger;
    localStorage.setItem("Active Route", this.router.url);
    this.global.afterRefreshPageSetToken();
    this.route.params.subscribe(params => this.mailId = params['id']);
    this.route.params.subscribe(params => this.mailvalue = params['compname']);
    console.log("second param" + this.mailvalue)
    this._mailService.GetCurrentMail(this.mailId)
      .subscribe((response) => {
        Object.assign(this.updateData, response);
        this.eyeIcon = this.updateData.hide == true ? "zmdi-eye" : "zmdi-eye-off";
        this.starIcon = this.updateData.star == true ? "zmdi-star" : "zmdi-star-outline";

        //Subject Dropdown

        this.getSenderName();

        this._updateService.GetAllSubject()
          .subscribe((response) => {
            this.subjectDropDown = response;
            this.subjectDropDown_SelectedId = [];
            for (let d of this.updateData.sub) {
              this.subjectDropDown_SelectedId.push(d.subjectId);
            }
          },
            error => {
              console.log(error);
            })

        //Specification Dropdown
        this._updateService.GetAllSpecification()
          .subscribe((response) => {
            this.specificationDropDown = response;
            this.specificationDropDown_SelectedId = [];
            for (let d of this.updateData.spec) {
              this.specificationDropDown_SelectedId.push(d.specificationId);
            }

          },
            error => {
              console.log(error);
            })

        //Specification Dropdown
        this._updateService.GetAllRemark()
          .subscribe((response) => {
            this.remarkDropDown = response;
            this.remarkDropDown_SelectedId = [];
            for (let d of this.updateData.remark) {
              this.remarkDropDown_SelectedId.push(d.remarkId);
            }
          },
            error => {
              console.log(error);
            })

      }, error => {
        info_noti(error);
      })
  }

  addCancelClick() {
    if (this.mailvalue == 'approved') {
      this.router.navigate(['/dashboard/approvedhc'])
    } else if (this.mailvalue == 'allapproved') {
      this.router.navigate(['/dashboard/getotpallapproved'])
    } else if (this.mailvalue == 'remark') {
      this.router.navigate(['/dashboard/remark'])
    } else if (this.mailvalue == 'showhidden') {
      this.router.navigate(['/dashboard/showhidden'])
    } else if (this.mailvalue == 'secifictaion') {
      this.router.navigate(['/dashboard/specification'])
    } else if (this.mailvalue == 'starred') {
      this.router.navigate(['/dashboard/staredhc'])
    } else if (this.mailvalue == 'subject') {
      this.router.navigate(['/dashboard/subject'])
    }

    this.updateForm.resetForm();
  }
  //DropDown Functions//
  subjectDropDown_Added = (term) => ({ subjectId: term, name: term });
  specificationDropDown_Added = (term) => ({ specificationId: term, name: term });
  remarkDropDown_Added = (term) => ({ remarkId: term, name: term });
  senderDropDown_Added = (term) => ({ senderId: term, name: term });
  //DropDown Functions//

  Eye_Click() {
    this.eyeIcon = this.eyeIcon == "zmdi-eye" ? "zmdi-eye-off" : "zmdi-eye";
    this.updateData.hide = this.eyeIcon == "zmdi-eye" ? true : false;
    if (this.updateData.hide) {
      info_noti("Hide Click.....");
    } else {
      info_noti("UnHide Click.....");
    }

  }

  Star_Click() {
    this.starIcon = this.starIcon == "zmdi-star" ? "zmdi-star-outline" : "zmdi-star";
    this.updateData.star = this.starIcon == "zmdi-star" ? true : false;
    if (this.updateData.star) {
      info_noti("Stared Click.....");
    } else {
      info_noti("UnStared Click.....");
    }
  }

  Update_HealthCardSubmit(addForm:NgForm) {

    //sub data

    this.submitted = true;
    if (addForm.form.invalid) {

      if (addForm.form.controls.senderId.invalid){
        $("#senderIdError").html("Sender Name is required")
    } else {
      $("#senderIdError").html("")
    }
    if (addForm.form.controls.subjectDropDown_SelectedId.invalid){
      $("#subjectIdError").html("Subject Name is required")
  } else {
    $("#subjectIdError").html("")
  }
  return;
}





    var localsub: Sub[] = new Array();
    for (let data of this.subjectDropDown_SelectedId) {
      if (isNaN(data)) {
        var newSub: Sub = {
          subjectId: 0,
          name: data.toString(),
        }
        localsub.push(newSub);
      }
      else {
        var oldSub: Sub = {
          subjectId: data,
          name: this.subjectDropDown.find(a => a.subjectId == data).name,
        }
        localsub.push(oldSub);
      }
    }

    //spec data
    var localspec: Specification[] = new Array();
    for (let data of this.specificationDropDown_SelectedId) {
      if (isNaN(data)) {
        var newSpec: Specification = {
          specificationId: 0,
          name: data.toString(),
        }
        localspec.push(newSpec);
      }
      else {
        var oldSpec: Specification = {
          specificationId: data,
          name: this.specificationDropDown.find(a => a.specificationId == data).name,
        }
        localspec.push(oldSpec);
      }
    }

    //remark data
    var localrmk: Remark[] = new Array();
    for (let data of this.remarkDropDown_SelectedId) {
      if (isNaN(data)) {
        var newRmk: Remark = {
          remarkId: 0,
          name: data.toString(),
        }
        localrmk.push(newRmk);
      }
      else {
        var oldRmk: Remark = {
          remarkId: data,
          name: this.remarkDropDown.find(a => a.remarkId == data).name,
        }
        localrmk.push(oldRmk);
      }
    }

    this.updateData.sub = localsub;
    this.updateData.spec = localspec;
    this.updateData.remark = localrmk;

    this._updateService.UpdateHealthCard(this.updateData)
      .subscribe((response) => {
        info_noti('Updated Successfully');

        if (this.mailvalue == 'approved') {
          this.router.navigate(['/dashboard/approvedhc'])
        } else if (this.mailvalue == 'allapproved') {
          this.router.navigate(['/dashboard/getotpallapproved'])
        } else if (this.mailvalue == 'remark') {
          this.router.navigate(['/dashboard/remark'])
        } else if (this.mailvalue == 'showhidden') {
          this.router.navigate(['/dashboard/showhidden'])
        } else if (this.mailvalue == 'secifictaion') {
          this.router.navigate(['/dashboard/specification'])
        } else if (this.mailvalue == 'starred') {
          this.router.navigate(['/dashboard/staredhc'])
        } else if (this.mailvalue == 'subject') {
          this.router.navigate(['/dashboard/subject'])
        }

        // this.router.navigateByUrl('/dashboard/approvedhc');
      },
        error => {
          console.log(error);
        });
  }

  senderIdEnter() {
    this.subjectId.focus();
  }
  subjectEnter() {
    $('#body').focus();
  }
  bodyEnter() {
    $('#date_time').focus();
  }
  dateEnter() {
    this.specificationId.focus();

  }
  spcificationEnter() {
    $('#amount').focus();
  }
  amountEnter() {
    this.remarkId.focus();

  }
  remarkEnter() {
    $('#eyeIcon').focus();
  }
  eyeEnter() {
    $('#starIcon').focus();
  }
  starEnter() {
    $('#saveBtn').focus();
  }
  getSenderName() {
    this.approvedService.GetSenderName().subscribe(res => {
      this.senderNameDropDown = res;
      // Object.assign(this.senderNameDropDown, res);

      console.log("Sender Name:" + this.senderNameDropDown)
    }, err => {
      info_noti("Error To get Sender Name");
    })
  }

}
